<template>
  <div id="footer">
    <mt-tabbar class="mint-tabbar is-fixed">
      <router-link to="/index/home" class="home" tag="mt-tab-item">
        <a href="javascript:;">
          <div class="mint-tab-item-icon">
            <img v-bind:src="homeTabImg" />
            <!-- <img src="../assets/img/homeChk.png"> -->
          </div>
          {{ $t("首页") }}
        </a>
      </router-link>
      <router-link to="/index/market" class="market" tag="mt-tab-item">
        <a href="javascript:;">
          <div class="mint-tab-item-icon">
            <img v-bind:src="marketTabImg" />
          </div>
          {{ $t("交易所") }}
        </a>
      </router-link>
      <router-link to="/index/wealth" class="wealth" tag="mt-tab-item">
        <a href="javascript:;">
          <div class="mint-tab-item-icon">
            <img v-bind:src="wealthTabImg" />
          </div>
          {{ $t("财富") }}
        </a>
      </router-link>
      <router-link to="/index/game" class="game" tag="mt-tab-item">
        <a href="javascript:;">
          <div class="mint-tab-item-icon">
            <img v-bind:src="gameTabImg" />
          </div>
          {{ $t("游戏") }}
        </a>
      </router-link>

      <router-link to="/index/mypage" class="mypage" tag="mt-tab-item">
        <a href="javascript:;">
          <div class="mint-tab-item-icon">
            <img v-bind:src="mySetupTabImg" />
          </div>
          {{ $t("我的") }}
        </a>
      </router-link>
    </mt-tabbar>
  </div>
</template>
<script>
import { httpGetUserInfo } from "../api/login";

var localImg = "../assets/img/";
export default {
  name: "FooterView",
  data() {
    return {
      homeTabImg: require("../assets/img/tab_ico_zichan_s.png"),
      marketTabImg: require("../assets/img/tab_ico_hangqing_n.png"),
      wealthTabImg: require("../assets/img/tab_ico_caifu_n.png"),
      findTabImg: require("../assets/img/tab_ico_faxian_n.png"),
      gameTabImg: require("../assets/img/tab_ico_faxian_n.png"),
      mySetupTabImg: require("../assets/img/tab_ico_user_n.png"),

      home: require("../assets/img/tab_ico_zichan_n.png"),
      homeChk: require("../assets/img/tab_ico_zichan_s.png"),
      market: require("../assets/img/tab_ico_hangqing_n.png"),
      marketChk: require("../assets/img/tab_ico_hangqing_s.png"),
      wealthTab: require("../assets/img/tab_ico_caifu_n.png"),
      wealthTabChk: require("../assets/img/tab_ico_caifu_s.png"),
      find: require("../assets/img/tab_ico_faxian_n.png"),
      findChk: require("../assets/img/tab_ico_faxian_s.png"),
      mySet: require("../assets/img/tab_ico_user_n.png"),
      mySetChk: require("../assets/img/tab_ico_user_s.png"),
    };
  },
  watch: {
    $route(to, from) {
      var urlName = to.path;
      switch (urlName) {
        case "/index/home":
          this.homeTabImg = this.homeChk;
          this.marketTabImg = this.market;
          this.wealthTabImg = this.wealthTab;
          this.findTabImg = this.find;
          this.gameTabImg = this.find;
          this.mySetupTabImg = this.mySet;
          document.querySelector("#index").style.paddingBottom = "55px";
          document.querySelector("#footer").style.display = "block";
          break;
        case "/index/market":
          this.homeTabImg = this.home;
          this.marketTabImg = this.marketChk;
          this.wealthTabImg = this.wealthTab;
          this.findTabImg = this.find;
          this.gameTabImg = this.find;
          this.mySetupTabImg = this.mySet;
          document.querySelector("#index").style.paddingBottom = "0";
          document.querySelector("#footer").style.display = "none";
          break;
        case "/index/wealth":
          this.homeTabImg = this.home;
          this.marketTabImg = this.market;
          this.wealthTabImg = this.wealthTabChk;
          this.findTabImg = this.find;
          this.gameTabImg = this.find;
          this.mySetupTabImg = this.mySet;
          document.querySelector("#index").style.paddingBottom = "55px";
          document.querySelector("#footer").style.display = "block";
          break;
        case "/index/find":
          this.homeTabImg = this.home;
          this.marketTabImg = this.market;
          this.wealthTabImg = this.wealthTab;
          this.findTabImg = this.findChk;
          this.mySetupTabImg = this.mySet;
          document.querySelector("#index").style.paddingBottom = "55px";
          document.querySelector("#footer").style.display = "block";
          break;
        case "/index/game":
          this.homeTabImg = this.home;
          this.marketTabImg = this.market;
          this.wealthTabImg = this.wealthTab;
          this.gameTabImg = this.findChk;
          this.mySetupTabImg = this.mySet;
          document.querySelector("#index").style.paddingBottom = "55px";
          document.querySelector("#footer").style.display = "block";
          break;
        case "/index/mypage":
          this.homeTabImg = this.home;
          this.marketTabImg = this.market;
          this.wealthTabImg = this.wealthTab;
          this.findTabImg = this.find;
          this.gameTabImg = this.find;
          this.mySetupTabImg = this.mySetChk;
          document.querySelector("#index").style.paddingBottom = "55px";
          document.querySelector("#footer").style.display = "block";
          break;
      }
    },
  },
  mounted() {
    this.getUserInfo();
    if (this.$route.path === "/index/market") {
      this.homeTabImg = this.home;
      this.marketTabImg = this.marketChk;
      this.wealthTabImg = this.wealthTab;
      this.findTabImg = this.find;
      this.gameTabImg = this.find;
      this.mySetupTabImg = this.mySet;
      document.querySelector("#index").style.paddingBottom = "0";
      document.querySelector("#footer").style.display = "none";
    }
  },
  methods: {
    getUserInfo() {
      httpGetUserInfo()
        .then((res) => {})
        .catch((e) => {});
    },
  },
};
</script>

<style scoped>
a {
  text-decoration: none;
  color: inherit;
}

.mint-tabbar.is-fixed {
  /*border-top:1px solid #e3e8ed;*/
  box-shadow: 0px -1px 5px #e3e3e3;
  z-index: 1;
}

.mint-tabbar > .mint-tab-item.is-selected {
  background-color: #fff;
  color: inherit;
}

.mint-tabbar > .mint-tab-item.is-selected {
  color: #8c92a8;
}

.router-link-active a {
  color: #0191f5;
}

.mint-tabbar > .mint-tab-item.is-selected {
  -webkit-tap-highlight-color: transparent !important;
}

.wealthTabImg {
  width: 59px;
  height: 59px;
  position: relative;
  top: -33px;
  left: -19px;
  margin-top: 0px;
}
</style>
